
const normalizeName = (name) => {
  if (typeof name !== "string") {
    return "";
  }
  return name.toLowerCase().trim().replace(/\s+/g, "");
};

const isReactSnapPrerender = () => (
  typeof navigator !== "undefined"
  && /ReactSnap/i.test(navigator.userAgent || "")
);

export { normalizeName, isReactSnapPrerender };
